import $ from 'jquery'
window.$ = $
window.jQuery = $

$(document).ready(function () {
    $(".editions__edition_img_box").click(function (){
        $(".editions__edition_img_box").removeClass('editions__edition_img_box_active')
        $(this).addClass('editions__edition_img_box_active')

        $('.group_f__text').removeClass('group_f__text_active')
        let t = '#'+$(this).attr('targetpanel')
        $(t).addClass('group_f__text_active')
    });
});